import React from 'react';
import TopologyToolbar from './components/TopologyToolbar';
import DuplicateInspectorModal from './components/DuplicateInspectorModal';
import historyManager from './history/historyManager';
import * as topologyEngine from './topology/topologyEngine';
import * as duplicateDetector from './duplicates/duplicateDetector';
import * as duplicatePlacementTool from './duplicate/duplicatePlacementTool';

export const id = 'spd-plus';
export const name = 'SPD+ Разметка';

export const getTools = () => ({});

export {
    TopologyToolbar,
    DuplicateInspectorModal,
    historyManager,
    topologyEngine,
    duplicateDetector,
    duplicatePlacementTool
};

export const Panel = (props) => {
    return <DuplicateInspectorModal {...props} />;
};

const spdPlusModule = {
    id,
    name,
    TopologyToolbar,
    DuplicateInspectorModal,
    historyManager,
    topologyEngine,
    duplicateDetector,
    duplicatePlacementTool,
    Panel,
    getTools
};

export default spdPlusModule;
